import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AddEditPersonalProtectiveEquipmentModal from './Add_Edit/AddEditPersonalProtectiveEquipment';
import DeletePersonalProtectiveEquipmentModal from './Delete/DeletePersonalProtectiveEquipment';
import { toSmartTitleCase } from '../../utils/toSmartTitleCase.js';
import { ODataGrid } from '../../Components/OElements/ODataGrid.js';
import rootReducer from '../../slices';
import {
	getPersonalProtectiveEquipmentList,
	getPersonalProtectiveEquipmentQuery,
	updatePersonalProtectiveEquipmentDocument,
	uploadFoldersFile,
} from '../../slices/thunks';
import PersonalProtectiveEquipmentFilesModal from './Modals/PersonalProtectiveEquipmentFilesModal';
import DeliverPersonalProtectiveEquipmentModal from './Modals/DeliverPersonalProtectiveEquipment';
import AddEditPersonalProtectiveEquipmentPickModal from './Add_Edit/AddEditPersonalProtectiveEquipmentPick.js';
import AddEditPersonalProtectiveEquipmentDeliveryModal from './Add_Edit/AddEditPersonalProtectiveEquipmentDelivery.js';
import AddEditPersonalProtectiveEquipmentReceiveModal from './Add_Edit/AddEditPersonalProtectiveEquipmentReceive.js';
import { useUser } from '../../Components/Hooks/useUserHooks.js';
import AddEditPersonalProtectiveEquipmentReturnModal from './Add_Edit/AddEditPersonalProtectiveEquipmentReturn.js';
import { Tooltip } from '@mantine/core';
import PersonalProtectiveEquipmentTransferModal from './Add_Edit/PersonalProtectiveEquipmentTransfer.js';
import { generateExcel } from '../../helpers/generateExcel.js';
import dayjs from 'dayjs';
import { getPersonalProtectiveEquipmentList as getPersonalProtectiveEquipmentListApi } from '../../helpers/warehouse/backend_helper.js';
import { generatePDF } from './Document/PPEDocument.js';
import useLogoLoader from '../../Components/Hooks/useLogoLoaderHooks.js';
import { toast } from 'react-toastify';
import useFileType from '../../Components/Hooks/useFileTypeHooks.js';
import { updateDocumentId } from '../../slices/personalProtectiveEquipment/reducer.js';

const PersonalProtectiveEquipmentList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();
	const { logoSrc } = useLogoLoader('login');
	const {file_type} = useFileType('EPP');
	const { user } = useUser();

	const [
		modalFilesPersonalProtectiveEquipment,
		setModalFilesPersonalProtectiveEquipment,
	] = useState(false);
	const [dataPersonalProtectiveEquipment, setDataPersonalProtectiveEquipment] =
		useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete PersonalProtectiveEquipment
	const [modal, setModal] = useState(false);
	const [modalReturn, setReturnModal] = useState(false);
	const [modalSelected, setModalSelected] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	const [modalDeliver, setModalDeliver] = useState(false);
	const [modalReceive, setModalReceive] = useState(false);
	const [modalTransfer, setModalTransfer] = useState(false);

	const [selectionProcessList, setSelectionProcessList] = useState([]);
	const [dataListSelect, setDataListSelect] = useState([]);
	//Tab
	const [activeTab, setActiveTab] = useState('1');

	// Documents updating
	const [loadingDocuments, setLoadingDocuments] = useState({});

	const selectorCategories = createSelector(
		state => state.PersonalProtectiveEquipments,
		data => ({
			dataList: data.itemPersonalProtectiveEquipmentList,
			isLoadingList: data.isLoadingList,
			isPersonalProtectiveEquipmentSuccess:
				data.isPersonalProtectiveEquipmentSuccess,
			error: data.error,
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isAddError: data.isAddError,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isUpdateError: data.isUpdateError,
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
		})
	);

	const { dataList, isLoadingList } = useSelector(selectorCategories);

	useEffect(() => {
		if (user?.role_code == 'CTO') {
			let establishment_list = null;
			if (user.establishment_ids.length !== 0) {
				establishment_list = user.establishment_ids.join(',');
			}
			dispatch(
				getPersonalProtectiveEquipmentList({
					status_code_list: 'END,AGD,RTD',
					establishment_list: establishment_list,
				})
			);
		} else {
			dispatch(getPersonalProtectiveEquipmentList());
		}
	}, [user]);

	function handleToggleModalFilesPersonalProtectiveEquipment(data) {
		setModalFilesPersonalProtectiveEquipment(
			!modalFilesPersonalProtectiveEquipment
		);
	}

	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalTransfer() {
		setModalTransfer(!modalTransfer);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleReturnModal() {
		setReturnModal(!modalReturn);
		toggleTab('1');
	}

	function handleToggleModalSelected() {
		setModalSelected(!modalSelected);
		toggleTab('1');

		if (modalSelected == true) {
			setSelectionProcessList([]);
		}
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	function handleToggleModalDeliver() {
		setModalDeliver(!modalDeliver);
	}

	function handleToggleModalReceive() {
		setModalReceive(!modalReceive);
	}

	// Update Data
	const handleClickEdit = data => {
		setDataPersonalProtectiveEquipment(data);
		handleToggleModal();
	};

	// Delete Data
	const handleClickDelete = data => {
		setDataPersonalProtectiveEquipment(data);
		setModalDelete(true);
	};

	// Update Data
	const handleClickDeliver = data => {
		setDataPersonalProtectiveEquipment(data);
		setModalDeliver(true);
	};

	// Update Data
	const handleClickReceive = data => {
		setDataPersonalProtectiveEquipment(data);
		setModalReceive(true);
	};

	const handleClickFile = data => {
		setDataPersonalProtectiveEquipment(data);
		handleToggleModalFilesPersonalProtectiveEquipment();
	};

	const uploadDocument = async (file, folderPaths, fileTypeId, establishmentId) => {
		if (!(file instanceof File)) {
			throw new Error("El archivo seleccionado no es válido.");
		}

		const formData = new FormData();
		formData.append("file", file);
		formData.append("file_type_id", fileTypeId);
		formData.append("establishment_id", establishmentId);

		folderPaths.forEach(path => formData.append("folder_paths", path));

		// console.log("FormData antes de la subida:");
		// for (let pair of formData.entries()) {
		// 	console.log(pair[0], pair[1]);
		// }

		try {
			const response = await dispatch(uploadFoldersFile(formData)).unwrap();
			return response;
		} catch (error) {
			console.error("Error uploading file:", error);
			throw error;
		}
	};

	const handleGenerateAssignmentDocument = async (data) => {
		toast.success(`Generando documento de asignación de EPP ${data.code}`, { autoClose: 3000 });
		try {
			setLoadingDocuments(prev => ({
				...prev,
				[data._id]: true,
			}));

			const ppe_updated_list = await getPersonalProtectiveEquipmentListApi({
				personal_protective_equipment_ids: [data._id]
			});

			// Generate all PDFs PPE updated and upload all
			for (const ppe of ppe_updated_list) {

				const file = await generatePDF(
					logoSrc,
					{
						code: 'RG-RH-03',
						generation_date: '01-01-2025',
						modification_date: '01-01-2025',
						scope: 'Toda la Organización',
						status: 'Documento Controlado',
						version: '05',
						establishment: {
							name: ppe.establishment.name
						},
						person: {
							name: ppe.person.name,
							rut: ppe.person.rut
						},
						items: ppe.assigned_items
					}
				);

				let document = null;
				if (file) {
					const folder = '/' + ppe.establishment_type.name + '/' + (ppe.code_siep ? ppe.establishment.code_siep + ' - ' : '') + ppe.establishment.name + '/Abastecimiento/EPP/Entrega';
					const updatedFolderPaths = folder;

					try {
						// Subir documento de EPP actualizado luego de devolución
						const document_updated = await uploadDocument(file, [updatedFolderPaths], file_type._id, ppe.establishment_id);
						// Actualizar documentación de EPP
						await dispatch(
							updatePersonalProtectiveEquipmentDocument({
								_id: data._id,
								document_id: document_updated[0]._id
							})
						).unwrap();
						dispatch(
							updateDocumentId({
								ppeId: data._id,
								documentId: document_updated[0]._id,
							})
						);

					} catch (error) {
						toast.error('No se pudo generar el documento de asignación', { autoClose: 3000 });
						console.log('Error updated epp', error)
						return;
					}
				}
			}
		} finally {
			setLoadingDocuments(prev => ({
				...prev,
				[data._id]: false,
			}));
		}
	}

	const exportDetailPPE = () => {
		const assignedItemsPPE = dataListSelect.flatMap(ppe =>
			ppe.assigned_items.map(
				assignedItem => 
					({
						...{
							'Código EPP': ppe.code,
							'Fecha': dayjs(ppe.assignment_date).format('DD-MM-YYYY'),
							'Código Centro de Costo': ppe?.cost_center?.code || '',
							'Nombre Centro de Costo': ppe?.cost_center?.name || ''
						},
						...{
							'Código Item': assignedItem.code || '',
							'Elemento': assignedItem.name,
							'Talla': assignedItem.size || '',
							'Color': assignedItem.color || '',
							'Cantidad': assignedItem.quantity,
							'Unidad': assignedItem.unit_measurement_name,
							'Precio': assignedItem.price,
						}
					})
			)
		)
		generateExcel(assignedItemsPPE, 'Detalles de EPP')
	}

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				enableColumnActions: false,
				accessorKey: 'categories',
				columnDefType: 'display',

				width: '3%',
				Cell: cellProps => {
					const personalProtectiveEquipment = cellProps.row.original;

					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li
											className={`list-inline-item ${
												['CTO'].includes(user.role_code) ||
												!['AGD'].includes(
													personalProtectiveEquipment
														.personal_protective_equipment_status
														.code
												)
													? 'disabled'
													: ''
											}`}
										>
											<Link
												to={'#'}
												onClick={e => {
													if (
														['CTO'].includes(user.role_code) ||
														!['AGD'].includes(
															personalProtectiveEquipment
																.personal_protective_equipment_status
																.code
														)
													) {
														e.preventDefault();
													} else {
														const fuelTankData =
															cellProps.row.original;
														setIsEdit(true);
														handleClickEdit(fuelTankData);
													}
												}}
												title='Editar'
												aria-disabled={
													['CTO'].includes(user.role_code) ||
													!['AGD'].includes(
														personalProtectiveEquipment
															.personal_protective_equipment_status
															.code
													)
												}
												className={
													['CTO'].includes(user.role_code) ||
													!['AGD'].includes(
														personalProtectiveEquipment
															.personal_protective_equipment_status
															.code
													)
														? 'text-muted'
														: ''
												}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										{(personalProtectiveEquipment.document_id ||
											personalProtectiveEquipment.receive_document_id ||
											personalProtectiveEquipment.pick_document_id) && (
											<li className='list-inline-item'>
												<Link
													to='#'
													onClick={() => {
														handleClickFile(
															personalProtectiveEquipment
														);
													}}
													title='Ver Documentos'
												>
													<i className='ri-file-search-line align-bottom me-2 text-muted'></i>
												</Link>
											</li>
										)}

										{!personalProtectiveEquipment.document_id && (
											<li className='list-inline-item'>
												<Link
													to='#'
													onClick={() => {
														if (!loadingDocuments[personalProtectiveEquipment._id]) {
															handleGenerateAssignmentDocument(
																personalProtectiveEquipment
															);
														}
													}}
													title='Generar Documento de Asignación'
													aria-disabled={
														loadingDocuments[personalProtectiveEquipment._id]
													}
													className={
														loadingDocuments[personalProtectiveEquipment._id]
															? 'disabled'
															: ''
													}
												>
													<i
														className={`ri-file-add-line align-bottom me-2 ${
															loadingDocuments[personalProtectiveEquipment._id]
																? 'text-muted opacity-50'
																: 'text-primary'
														}`}
													/>
												</Link>
											</li>
										)}

										<li
											className={`list-inline-item ${
												['CTO', 'CHN'].includes(user.role_code) ||
												!['AGD', 'RTD'].includes(
													personalProtectiveEquipment
														.personal_protective_equipment_status
														.code
												)
													? 'disabled'
													: ''
											}`}
											title='Entregar'
										>
											<Link
												to='#'
												onClick={e => {
													if (
														['CHN'].includes(user.role_code) ||
														!['AGD', 'RTD'].includes(
															personalProtectiveEquipment
																.personal_protective_equipment_status
																.code
														)
													) {
														e.preventDefault();
													} else {
														handleClickDeliver(
															personalProtectiveEquipment
														);
													}
												}}
												title='Entregar'
												aria-disabled={
													['CHN'].includes(user.role_code) ||
													!['AGD', 'RTD'].includes(
														personalProtectiveEquipment
															.personal_protective_equipment_status
															.code
													)
												}
												className={
													['CHN'].includes(user.role_code) ||
													!['AGD', 'RTD'].includes(
														personalProtectiveEquipment
															.personal_protective_equipment_status
															.code
													)
														? 'text-muted'
														: ''
												}
											>
												<i className={`${Icons.handIcons} align-bottom me-2 text-muted`}></i>
											</Link>
										</li>

										<li
											className={`list-inline-item ${
												['CTO', 'CHN'].includes(user.role_code) ||
												!['DVT'].includes(
													personalProtectiveEquipment
														.personal_protective_equipment_status
														.code
												)
													? 'disabled'
													: ''
											}`}
											title='Recepcionar'
										>
											<Link
												to='#'
												onClick={e => {
													if (
														['CTO', 'CHN'].includes(user.role_code) ||
														!['DVT'].includes(
															personalProtectiveEquipment
																.personal_protective_equipment_status
																.code
														)
													) {
														e.preventDefault();
													} else {
														handleClickReceive(
															personalProtectiveEquipment
														);
													}
												}}
												title='Recepcionar'
												aria-disabled={
													['CTO', 'CHN'].includes(user.role_code) ||
													!['DVT'].includes(
														personalProtectiveEquipment
															.personal_protective_equipment_status
															.code
													)
												}
												className={
													['CTO', 'CHN'].includes(user.role_code) ||
													!['DVT'].includes(
														personalProtectiveEquipment
															.personal_protective_equipment_status
															.code
													)
														? 'text-muted'
														: ''
												}
											>
												<i className='icon-undo-2 align-bottom me-2 text-muted'></i>
											</Link>
										</li>

										<li
											className={`list-inline-item ${
												['CTO', 'CHN'].includes(user.role_code) ||
												['CND', 'END', 'RTD', 'RPD'].includes(
													personalProtectiveEquipment
														.personal_protective_equipment_status
														.code
												)
													? 'disabled'
													: ''
											}`}
										>
											<Link
												to='#'
												className={`remove-item-btn ${
													['CTO', 'CHN'].includes(user.role_code) ||
													['CND', 'END', 'RTD', 'RPD'].includes(
														personalProtectiveEquipment
															.personal_protective_equipment_status
															.code
													)
														? 'text-muted'
														: ''
												}`}
												onClick={e => {
													if (
														['CTO', 'CHN'].includes(user.role_code) ||
														['CND', 'END', 'RTD', 'RPD'].includes(
															personalProtectiveEquipment
																.personal_protective_equipment_status
																.code
														)
													) {
														e.preventDefault();
													} else {
														handleClickDelete(
															personalProtectiveEquipment
														);
													}
												}}
												title='Cancelar'
												aria-disabled={
													['CTO', 'CHN'].includes(user.role_code) ||
													['CND', 'END', 'RTD', 'RPD'].includes(
														personalProtectiveEquipment
															.personal_protective_equipment_status
															.code
													)
												}
											>
												<i className='ri-close-circle-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Código',
				accessorKey: 'code',
				size: 'auto',
				defaultSort: 'desc',
			},
			{
				header: 'Estado',
				accessorKey: 'personal_protective_equipment_status.name',
				size: 'auto',
				dataType: 'multi-select',
				accessorFn: row => {
					return row.personal_protective_equipment_status.name;
				},
				Cell: ({ row }) => {
					let status = row.original.personal_protective_equipment_status;
					let bgColor = status?.bgcolor;
					let txColor = status?.txcolor;
					return (
						<div>
							<span
								className={`badge`}
								style={{ backgroundColor: bgColor, color: txColor }}
							>
								{status ? status.name : ''}
							</span>
						</div>
					);
				},
			},
			{
				header: 'Fecha',
				accessorKey: 'assignment_date',
				dataType: 'date',
				size: 'auto',
				Cell: ({ row }) => {
					let status =
						row.original.personal_protective_equipment_status.code;
					let date = row.original.assignment_date;
					if (status == 'DVT') {
						date = row.original.return_date;
					}

					return new Date(date).toLocaleDateString('es-CL', {
						year: 'numeric',
						month: '2-digit',
						day: '2-digit',
					});
				},
			},
			{
				header: 'Entrega',
				accessorKey: 'delivery_date',
				dataType: 'date',
				size: 'auto',
			},
			{
				header: 'Origen',
				accessorKey: 'warehouse_name',
				size: 'auto',
				size: 'auto',
				dataType: 'multi-select',
				accessorFn: row => {
					let status = row.personal_protective_equipment_status.code;
					let warehouse_name = row.warehouse?.name;
					if (status == 'DVT') {
						warehouse_name = row.establishment?.name;
					}
					return warehouse_name;
				},
				Cell: ({ row }) => {
					let status =
						row.original.personal_protective_equipment_status.code;
					let warehouse_name = toSmartTitleCase(
						row.original.warehouse?.name
					);
					if (status == 'DVT') {
						warehouse_name = toSmartTitleCase(
							row.original.establishment?.name
						);
					}
					return warehouse_name;
				},
			},
			{
				header: 'Detino',
				accessorKey: 'establishment_name',
				size: 'auto',
				size: 'auto',
				dataType: 'multi-select',
				accessorFn: row => {
					let status = row.personal_protective_equipment_status.code;
					let establishment_name = row.establishment?.name;
					if (status == 'DVT') {
						establishment_name = row.warehouse?.name;
					}
					return establishment_name;
				},
				Cell: ({ row }) => {
					let status =
						row.original.personal_protective_equipment_status.code;
					let establishment_name = row.original.establishment?.name;
					if (status == 'DVT') {
						establishment_name = row.original.warehouse?.name;
					}
					return establishment_name;
				},
			},
			{
				header: 'Persona',
				accessorKey: 'person.name',
				size: 'auto',
				dataType: 'multi-select',
			},
			{
				header: 'Motivo',
				accessorKey: 'personal_protective_equipment_reason.name',
				size: 'auto',
				dataType: 'multi-select',
				accessorFn: row => {
					return row.personal_protective_equipment_reason?.name;
				},
				Cell: ({ row }) => {
					let status = row.original.personal_protective_equipment_reason;
					let bgColor = status?.bgcolor;
					let txColor = status?.txcolor;
					return (
						<div>
							<span
								className={`badge`}
								style={{ backgroundColor: bgColor, color: txColor }}
							>
								{status ? status.name : ''}
							</span>
						</div>
					);
				},
			},
			{
				header: 'Detalle',
				accessorKey: 'reason',
				size: 'auto',
				visible: false,
			},
			{
				header: 'Persona Retira',
				accessorKey: 'pick_person_name',
				size: 'auto',
				visible: false,
				Cell: ({ row }) => {
					let person_name = row.original.pick_person?.[0]?.name || '-';
					return person_name;
				},
			},
			{
				header: 'Fecha Retiro',
				accessorKey: 'pick_date',
				dataType: 'date',
				size: 'auto',
			},
			{
				header: 'Persona Entrega',
				accessorKey: 'delivery_person_name',
				size: 'auto',
				visible: false,
				Cell: ({ row }) => {
					let person_name = row.original.delivery_person?.[0]?.name || '-';
					return person_name;
				},
			},
			{
				header: 'Persona Recepción',
				accessorKey: 'receive_person_name',
				size: 'auto',
				visible: false,
				Cell: ({ row }) => {
					let person_name = row.original.receive_person?.[0]?.name || '-';
					return person_name;
				},
			},
			{
				header: 'Recepción Bodega',
				accessorKey: 'receive_date',
				dataType: 'date',
				size: 'auto',
			},
		],
		[
			handleClickDelete,
			handleClickFile,
			handleClickReceive,
			handleClickDeliver,
		]
	);

	useEffect(() => {
		if (selectionProcessList) {
			let selectionItems = [];
			Object.entries(selectionProcessList).forEach(([key, value]) => {
				if (key != null) {
					selectionItems.push(dataList.find(item => item._id == key));
				}
			});
			setDataListSelect(selectionItems);
		}
	}, [selectionProcessList]);

	const handleCleanSelection = async () => {
		setSelectionProcessList([]);
	};

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						<CardBody>
							<ODataGrid
								columns={columns}
								data={dataList || []}
								enableRowSelection={(row) => (
									// Only allow row selection has status is not CND or DVT
									!['CND', 'DVT'].includes(row.original.personal_protective_equipment_status.code) && 
									// Only allow row selection if the user's role_code is not CTO
									user.role_code !== 'CTO' &&
									// Only allow row selection if warehouse has code_sap
									row.original.warehouse?.code_sap != null
								)}
								customToolbarActions={() => {
									const selectedRows = Object.keys(selectionProcessList)
										.map(rowId => dataList.find(item => item._id === rowId))
										.filter(Boolean);
									
									const now = new Date();
									const start = new Date(now.getFullYear(), now.getMonth() - 1, 25); // start date: 25th of the previous month
									const end = new Date(now.getFullYear(), now.getMonth() + 1, 23);   // end date: 23rd of the next month

									// Check if every selected row has status AGD
									const canPick = selectedRows.every(row => {
										return ['AGD'].includes(row.personal_protective_equipment_status.code);
									});
									// Check if every selected rows has valid creation_date to return
									const canReturn = selectedRows.every(row => {
										if (!row.creation_date) return false;
										const creationDate = new Date(row.creation_date);
										return creationDate >= start && creationDate <= end;
									});

									return (
										<div className="d-flex justify-content-start gap-2">
											{(
												user.role_code !== 'CHN' && 
												user.role_code !== 'CTO' && 
												dataListSelect && 
												dataListSelect.length > 0 && (
													<Tooltip label='Exportar Detalle EPP' position='top' withinPortal>
														<button
															className='btn d-flex align-items-center btn-tooltip-hover gap-1'
															onClick={() => {
															exportDetailPPE();
															}}
														>
															<i className='ri-file-excel-2-fill icon-tooltop-size'></i>
															<span>Exportar</span>
														</button>
													</Tooltip>
												)
											)}
											{(
												user.role_code !== 'CHN' && 
												user.role_code !== 'CTO' && 
												dataListSelect && 
												dataListSelect.length > 0 && 
												canPick && (
													<Tooltip label='Realizar un Retiro' position='top' withinPortal>
														<button
															className='btn d-flex align-items-center btn-tooltip-hover gap-1'
															onClick={() => {
															handleToggleModalSelected();
															}}
														>
															<i className='ri-add-line icon-tooltop-size'></i>
															<span>Retiro</span>
														</button>
													</Tooltip>	
												)
											)}
											{(
												user.role_code !== 'CHN' && 
												user.role_code !== 'CTO' && 
												!selectedRows?.length && (
													<Tooltip label='Asignar EPP' position='top' withinPortal>
														<button
															className='btn d-flex align-items-center btn-tooltip-hover gap-1'
															onClick={() => {
															setIsEdit(false);
															setDataPersonalProtectiveEquipment({});
															handleToggleModal();
															}}
														>
															<i className='ri-add-line icon-tooltop-size'></i>
															<span>Asignar</span>
														</button>
													</Tooltip>	
												)
											)}
											{(
												user.role_code !== 'CHN' && 
												user.role_code !== 'CTO' && 
												dataListSelect && 
												dataListSelect.length > 0 && 
												canReturn && (
													<Tooltip label='Devolver EPP' position='top' withinPortal>
														<button
														className='btn d-flex align-items-center btn-tooltip-hover gap-1'
														onClick={() => {
															setIsEdit(false);
															setDataPersonalProtectiveEquipment({});
															handleToggleReturnModal();
														}}
														>
														<i className='ri-arrow-go-back-line icon-tooltop-size'></i>
														<span>Devolver</span>
														</button>
													</Tooltip>
												)
											)}
										</div>
									);
								}}


								nameFile={'equipamiento_de_proteccion_personal'}
								{...(user.role_code !== 'CHN' &&
									user.role_code !== 'CTO' && {
										selectAllMode: 'all',
										getRowIdTable: originalRow => originalRow._id,
										selection: {
											rowSelection: selectionProcessList,
											setRowSelection: setSelectionProcessList,
										},
									})}
							/>
							{/* ODataGrid Remote */}
							{/* <ODataGrid
								columns={columns}
								getDataFunc={getPersonalProtectiveEquipmentQuery}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								queryPopulate={[
									'warehouse',
									'establishment',
									'person',
									'personal_protective_equipment_status',
									'personal_protective_equipment_reason',
									'pick_person',
									'receive_person',
									'delivery_person',
								]}
								// data={dataList || []}
								enableRowSelection={row =>
									row.original.personal_protective_equipment_status
										.code === 'AGD' && user.role_code !== 'CTO'
								}
								nameFile={'equipamiento_de_proteccion_personal'}
								{...(user.role_code !== 'CHN' &&
									user.role_code !== 'CTO' && {
										selectAllMode: 'all',
										getRowIdTable: originalRow => originalRow._id,
										selection: {
											rowSelection: selectionProcessList,
											setRowSelection: setSelectionProcessList,
										},
									})}
							/> */}
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditPersonalProtectiveEquipmentModal
				dataPersonalProtectiveEquipment={dataPersonalProtectiveEquipment}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<AddEditPersonalProtectiveEquipmentReturnModal
				dataListSelect={dataListSelect}
				isEdit={isEdit}
				isOpen={modalReturn}
				handleToggleReturnModal={handleToggleReturnModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				onCleanSelection={handleCleanSelection}
			/>

			<AddEditPersonalProtectiveEquipmentPickModal
				dataListSelect={dataListSelect}
				isOpen={modalSelected}
				handleToggleModalSelected={handleToggleModalSelected}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<AddEditPersonalProtectiveEquipmentDeliveryModal
				dataPersonalProtectiveEquipment={dataPersonalProtectiveEquipment}
				isOpen={modalDeliver}
				handleToggleModalDeliver={handleToggleModalDeliver}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<AddEditPersonalProtectiveEquipmentReceiveModal
				dataPersonalProtectiveEquipment={dataPersonalProtectiveEquipment}
				isOpen={modalReceive}
				handleToggleModalReceive={handleToggleModalReceive}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<DeletePersonalProtectiveEquipmentModal
				dataPersonalProtectiveEquipment={dataPersonalProtectiveEquipment}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>

			{/* <DeliverPersonalProtectiveEquipmentModal
				dataPersonalProtectiveEquipment={dataPersonalProtectiveEquipment}
				isOpen={modalDeliver}
				handlerToggleModal={handleToggleModalDeliver}
			/> */}

			<PersonalProtectiveEquipmentFilesModal
				dataPersonalProtectiveEquipment={dataPersonalProtectiveEquipment}
				isOpen={modalFilesPersonalProtectiveEquipment}
				handleToggleModal={
					handleToggleModalFilesPersonalProtectiveEquipment
				}
			/>

			<PersonalProtectiveEquipmentTransferModal
				dataPersonalProtectiveEquipment={dataPersonalProtectiveEquipment}
				isEdit={isEdit}
				isOpen={modalTransfer}
				handleToggleModal={handleToggleModalTransfer}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</React.Fragment>
	);
};

export default PersonalProtectiveEquipmentList;
